/* unplugin-vue-components disabled */import { render } from "./VariantCheckboxGroup.vue?vue&type=template&id=89a1ff84&scoped=true&ts=true"
import script from "./VariantCheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./VariantCheckboxGroup.vue?vue&type=script&lang=ts"

import "./VariantCheckboxGroup.vue?vue&type=style&index=0&id=89a1ff84&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a1ff84"]])

export default __exports__